import { ready, on, toggleClass } from 'domassist';

ready(() => {
  on('[data-toggle]', 'click', function(e) {
    const el = this;
    const className = el.getAttribute('data-toggle');
    const target = el.getAttribute('data-toggle-target') || el;
    toggleClass(target, className);
  });
});
